import { getEnv } from 'mobx-easy';
import { RootEnv } from '../helpers/create-store';

class HttpService {
	static async get<T>(url: string): Promise<T> {
		const response = await fetch(url, { headers: HttpService.headers });

		if (!response.ok) {
			throw new Error(`Failed to get ${url}`);
		}

		const data = await response.text();

		try {
			return JSON.parse(data);
		} catch (e) {
			return e;
		}
	}

	static async post(url: string, body: object) {
		const response = await fetch(url, {
			method: 'POST',
			headers: HttpService.headers,
			body: JSON.stringify(body)
		});

		if (!response.ok) {
			throw new Error(`Failed to post ${url}`);
		}

		return response.json();
	}

	private static get headers() {
		const token = getEnv<RootEnv>().tokenService.token;

		let headers = {
			'Content-Type': 'application/json'
		};

		if (token) {
			headers['Authorization'] = `Token token=${token}`;
		}

		return headers;
	}
}
export default HttpService;
